module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-depart-form-view",
    attrs: {
      "width": "850px",
      "title": "部门详情",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [(_vm.departDetail) ? _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门名称："
    }
  }, [_vm._v(" " + _vm._s(_vm.departDetail.deptname || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门管理员："
    }
  }, [_vm._v(_vm._s(_vm.departDetail.deptManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("部门人员(" + _vm._s(_vm.departDetail.userList.length) + ")")]), _vm._v(" "), _c('el-table', {
    ref: "companyRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.departDetail.userList,
      "highlight-current-row": "",
      "height": 500
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "软件类型",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e9be811"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/DepartManage/ModalFormView.vue
// module id = 1777
// module chunks = 9